import { CheckCircle, CopyClipboard } from '../../assets/icons';
import { Button } from '../AntD/Button/Button';
import { Input, Tooltip } from 'antd';
import './CopyClipboardControl.scss';

/**
 *  @typedef {object} CopyClipboardControlProps
 *  @property {string} linkText
 *  @property {boolean} copied
 *  @property {()=>void} handleCopy
 *  @property {boolean} showCopyBtn
 *  @param {CopyClipboardControlProps} props
 */
const CopyClipboardControl = (props) => {
  return (
    <Input
      value={props.linkText}
      className='copy-clipboard-control'
      readOnly
      addonAfter={
        !props.showCopyBtn && (
          <Tooltip title='Copy URL'>
            <Button type='text' onClick={props.handleCopy} icon={props.copied ? <CheckCircle /> : <CopyClipboard />} />
          </Tooltip>
        )
      }
    />
  );
};

export default CopyClipboardControl;
